module.exports = __webpack_public_path__ + "static/media/flooring3.21c4a2c5.jpg";